/******************************************************************************/
/************************ Cakes Wag Bags Cart Logic ***************************/
/******************************************************************************/


(function () {
  'use strict';

  const WAG_BAG_HANDLES = [
    'cheezies-wag-bags',
    'bark-kwa-pork-wag-bags',
    'bark-kwa-beef-wag-bags',
    'something-fishy-wag-bags'
  ];

  const WAG_BAG_NAMES = [
    'cheezies wag bags',
    'bark-kwa pork wag bags',
    'bark-kwa beef wag bags',
    'something fishy wag bags'
  ];

  let isUpdatingCart = false;
  let observerTimer = null;

  function isCartPage() {
    return (
      window.location.pathname === '/cart' ||
      window.location.pathname.startsWith('/cart/')
    );
  }

  function getShopifyRoot() {
    if (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) {
      return window.Shopify.routes.root;
    }

    return '/';
  }

  function normalize(value) {
    return String(value || '').trim();
  }

  function isWagBagItem(item) {
    if (!item) return false;

    const handle = normalize(item.handle).toLowerCase();

    if (WAG_BAG_HANDLES.includes(handle)) {
      return true;
    }

    const properties = item.properties || {};

    const addonProperty = normalize(
      properties['_Wag Bag Add-on'] ||
      properties['Wag Bag Add-on']
    ).toLowerCase();

    return (
      addonProperty === 'yes' ||
      addonProperty === 'true'
    );
  }

  function isWagBagText(text) {
    const normalizedText = normalize(text).toLowerCase();

    return WAG_BAG_NAMES.some(function (name) {
      return normalizedText.includes(name);
    });
  }

  function getBundleId(item) {
    if (!item || !item.properties) return '';

    return normalize(
      item.properties['_Wag Bundle ID'] ||
      item.properties['Wag Bundle ID'] ||
      item.properties['_wag_bundle_id']
    );
  }

  function getCartRows() {
    return Array.from(
      document.querySelectorAll(
        '#main-cart-items tr.cart-item, ' +
        '#main-cart-items .cart-item, ' +
        '#main-cart-items .cart__row'
      )
    );
  }

  function getRemoveButton(target) {
    if (!(target instanceof Element)) return null;

    return target.closest(
      'cart-remove-button, ' +
      'cart-remove-button a, ' +
      'a[href*="/cart/change"], ' +
      '.cart-remove-button'
    );
  }

  function getLineNumber(removeButton, row) {
    const removeContainer =
      removeButton.matches('cart-remove-button')
        ? removeButton
        : removeButton.closest('cart-remove-button');

    if (removeContainer) {
      const dataIndex = Number(
        removeContainer.getAttribute('data-index')
      );

      if (dataIndex > 0) {
        return dataIndex;
      }
    }

    if (row && row.id) {
      const match = row.id.match(/CartItem-(\d+)/i);

      if (match) {
        return Number(match[1]);
      }
    }

    const rows = getCartRows();
    const rowIndex = rows.indexOf(row);

    return rowIndex >= 0 ? rowIndex + 1 : 0;
  }

  function getCheckoutElements() {
    return Array.from(
      document.querySelectorAll(
        'button[name="checkout"], ' +
        'input[name="checkout"], ' +
        '#checkout, ' +
        '.cart__checkout-button, ' +
        'a[href*="/checkout"]'
      )
    );
  }

  function lockCart(message) {
    isUpdatingCart = true;

    document.documentElement.classList.add(
      'wag-cart-is-updating'
    );

    getCheckoutElements().forEach(function (element) {
      element.dataset.wagWasDisabled =
        element.disabled ? 'true' : 'false';

      element.disabled = true;
      element.setAttribute('aria-disabled', 'true');
      element.style.pointerEvents = 'none';
    });

    let notice = document.querySelector(
      '.wag-cart-update-notice'
    );

    if (!notice) {
      notice = document.createElement('div');
      notice.className = 'wag-cart-update-notice';

      notice.style.position = 'fixed';
      notice.style.left = '50%';
      notice.style.bottom = '30px';
      notice.style.transform = 'translateX(-50%)';
      notice.style.zIndex = '999999';
      notice.style.padding = '12px 18px';
      notice.style.border = '1px solid rgba(0,0,0,0.15)';
      notice.style.borderRadius = '6px';
      notice.style.background = '#ffffff';
      notice.style.boxShadow =
        '0 4px 18px rgba(0,0,0,0.15)';
      notice.style.fontSize = '14px';
      notice.style.fontWeight = '600';

      document.body.appendChild(notice);
    }

    notice.textContent =
      message || 'Updating your cart...';
  }

  function unlockCart() {
    isUpdatingCart = false;

    document.documentElement.classList.remove(
      'wag-cart-is-updating'
    );

    getCheckoutElements().forEach(function (element) {
      if (
        element.dataset.wagWasDisabled !== 'true'
      ) {
        element.disabled = false;
      }

      element.removeAttribute('aria-disabled');
      element.style.pointerEvents = '';

      delete element.dataset.wagWasDisabled;
    });

    const notice = document.querySelector(
      '.wag-cart-update-notice'
    );

    if (notice) {
      notice.remove();
    }
  }

  async function fetchLatestCart() {
    const response = await fetch(
      getShopifyRoot() +
        'cart.js?t=' +
        Date.now(),
      {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        },
        cache: 'no-store'
      }
    );

    if (!response.ok) {
      throw new Error(
        'Unable to load cart: ' + response.status
      );
    }

    return response.json();
  }

  async function sendCartUpdates(updates) {
    const response = await fetch(
      getShopifyRoot() + 'cart/update.js',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          updates: updates
        })
      }
    );

    if (!response.ok) {
      let errorMessage =
        'Unable to update cart: ' + response.status;

      try {
        const errorData = await response.json();

        if (errorData.description) {
          errorMessage = errorData.description;
        }
      } catch (error) {
        // Keep default error.
      }

      throw new Error(errorMessage);
    }

    return response.json();
  }

  function disableWagBagLinksAndQuantity() {
    if (!isCartPage()) return;

    getCartRows().forEach(function (row) {
      if (!isWagBagText(row.innerText)) return;

      row
        .querySelectorAll(
          '.quantity-popover-container, ' +
          'quantity-input, ' +
          '.quantity'
        )
        .forEach(function (element) {
          element.style.setProperty(
            'display',
            'none',
            'important'
          );
        });

      row.querySelectorAll('a').forEach(function (link) {
        const href = normalize(
          link.getAttribute('href')
        );

        const isRemoveLink =
          link.closest('cart-remove-button') ||
          href.includes('/cart/change');

        if (isRemoveLink) return;

        link.removeAttribute('href');
        link.style.pointerEvents = 'none';
        link.style.cursor = 'default';
      });
    });
  }

  function addWagBagQuantityText(cart) {
    if (!cart || !Array.isArray(cart.items)) return;

    const rows = getCartRows();

    rows.forEach(function (row, index) {
      row
        .querySelectorAll('.wag-selected-qty')
        .forEach(function (element) {
          element.remove();
        });

      const item = cart.items[index];

      if (!item || !isWagBagItem(item)) return;

      const title =
        row.querySelector('.cart-item__name') ||
        row.querySelector('.cart__product-title') ||
        row.querySelector('a[href*="/products"]');

      if (!title) return;

      const quantity = Number(item.quantity || 0);

      const quantityText = document.createElement('div');

      quantityText.className = 'wag-selected-qty';
      quantityText.textContent =
        'Selected Bags: ' +
        quantity +
        (quantity === 1 ? ' Bag' : ' Bags');

      title.insertAdjacentElement(
        'afterend',
        quantityText
      );
    });
  }

  function buildRemovalUpdates(cart, clickedItem) {
    const updates = {};

    if (
      !cart ||
      !Array.isArray(cart.items) ||
      !clickedItem
    ) {
      return updates;
    }

    /*
     * Always remove the clicked cart line.
     */
    updates[clickedItem.key] = 0;

    /*
     * When the clicked item is itself a Wag Bag,
     * remove only that Wag Bag.
     */
    if (isWagBagItem(clickedItem)) {
      return updates;
    }

    const cakeBundleId = getBundleId(clickedItem);

    /*
     * Normal products without a Wag Bundle ID
     * are removed individually.
     */
    if (!cakeBundleId) {
      return updates;
    }

    /*
     * Remove every remaining Wag Bag linked
     * to this cake bundle.
     */
    cart.items.forEach(function (item) {
      if (!isWagBagItem(item)) return;

      const wagBundleId = getBundleId(item);

      if (wagBundleId === cakeBundleId) {
        updates[item.key] = 0;
      }
    });

    return updates;
  }

  function buildOrphanWagBagUpdates(cart) {
    const updates = {};

    if (!cart || !Array.isArray(cart.items)) {
      return updates;
    }

    const activeMainBundles = new Set();

    cart.items.forEach(function (item) {
      if (isWagBagItem(item)) return;

      const bundleId = getBundleId(item);

      if (bundleId) {
        activeMainBundles.add(bundleId);
      }
    });

    cart.items.forEach(function (item) {
      if (!isWagBagItem(item)) return;

      const bundleId = getBundleId(item);

      if (
        bundleId &&
        !activeMainBundles.has(bundleId)
      ) {
        updates[item.key] = 0;
      }
    });

    return updates;
  }

  async function removeClickedCartItem(
    removeButton,
    row
  ) {
    if (isUpdatingCart) return;

    const lineNumber = getLineNumber(
      removeButton,
      row
    );

    if (!lineNumber) {
      console.error(
        'Unable to detect the cart line number.'
      );

      return;
    }

    lockCart('Updating your cart...');

    if (row) {
      row.style.opacity = '0.45';
      row.style.pointerEvents = 'none';
    }

    try {
      /*
       * Always load a fresh cart.
       * Do not use an old cart cache.
       */
      const cart = await fetchLatestCart();

      const clickedItem =
        cart.items[lineNumber - 1];

      if (!clickedItem) {
        throw new Error(
          'The selected cart item could not be found.'
        );
      }

      const isClickedWagBag =
        isWagBagItem(clickedItem);

      lockCart(
        isClickedWagBag
          ? 'Removing Wag Bag...'
          : getBundleId(clickedItem)
            ? 'Removing cake and Wag Bags...'
            : 'Removing product...'
      );

      const updates = buildRemovalUpdates(
        cart,
        clickedItem
      );

      if (!Object.keys(updates).length) {
        throw new Error(
          'No cart items were selected for removal.'
        );
      }

      await sendCartUpdates(updates);

      /*
       * Shopify cart is already fully updated
       * before the page reload starts.
       */
      window.location.reload();
    } catch (error) {
      console.error(
        'Cart removal error:',
        error
      );

      if (row) {
        row.style.opacity = '';
        row.style.pointerEvents = '';
      }

      unlockCart();

      alert(
        'The cart could not be updated. Please try again.'
      );
    }
  }

  async function cleanOrphanWagBags() {
    if (!isCartPage() || isUpdatingCart) return;

    try {
      const cart = await fetchLatestCart();

      disableWagBagLinksAndQuantity();
      addWagBagQuantityText(cart);

      const updates =
        buildOrphanWagBagUpdates(cart);

      if (!Object.keys(updates).length) {
        return;
      }

      lockCart('Removing unlinked Wag Bags...');

      await sendCartUpdates(updates);

      window.location.reload();
    } catch (error) {
      console.error(
        'Orphan Wag Bag cleanup error:',
        error
      );

      unlockCart();
    }
  }

  function handleRemoveClick(event) {
    if (!isCartPage() || isUpdatingCart) return;

    const removeButton =
      getRemoveButton(event.target);

    if (!removeButton) return;

    const row = removeButton.closest(
      'tr.cart-item, .cart-item, .cart__row'
    );

    if (!row) return;

    /*
     * Stop the Refresh theme cart.js handler.
     * Our single update request handles the deletion.
     */
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    removeClickedCartItem(
      removeButton,
      row
    );
  }

  function blockCheckoutWhileUpdating(event) {
    if (!isUpdatingCart) return;

    if (!(event.target instanceof Element)) return;

    const checkoutElement =
      event.target.closest(
        'button[name="checkout"], ' +
        'input[name="checkout"], ' +
        '#checkout, ' +
        '.cart__checkout-button, ' +
        'a[href*="/checkout"]'
      );

    if (!checkoutElement) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  async function initialize() {
    if (!isCartPage()) return;

    disableWagBagLinksAndQuantity();

    try {
      const cart = await fetchLatestCart();

      addWagBagQuantityText(cart);

      const orphanUpdates =
        buildOrphanWagBagUpdates(cart);

      if (Object.keys(orphanUpdates).length) {
        lockCart('Removing unlinked Wag Bags...');

        await sendCartUpdates(orphanUpdates);

        window.location.reload();
      }
    } catch (error) {
      console.error(
        'Initial Wag Bag cart check failed:',
        error
      );

      unlockCart();
    }
  }

  document.addEventListener(
    'DOMContentLoaded',
    initialize
  );

  /*
   * Capture mode runs before the Refresh theme
   * cart-remove-button JavaScript.
   */
  document.addEventListener(
    'click',
    handleRemoveClick,
    true
  );

  document.addEventListener(
    'click',
    blockCheckoutWhileUpdating,
    true
  );

  document.addEventListener(
    'cart:updated',
    function () {
      if (!isUpdatingCart) {
        cleanOrphanWagBags();
      }
    }
  );

  document.addEventListener(
    'cart:refresh',
    function () {
      if (!isUpdatingCart) {
        cleanOrphanWagBags();
      }
    }
  );

  const cartObserver = new MutationObserver(
    function () {
      if (!isCartPage()) return;

      clearTimeout(observerTimer);

      observerTimer = setTimeout(function () {
        disableWagBagLinksAndQuantity();
      }, 80);
    }
  );

  cartObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
